// Escapa texto vindo do bot/servidor antes de ir para o terminal (v-html)
export function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Resume um erro do axios para o terminal
export function describeError(error) {
  if (error.response) {
    const data = error.response.data;
    const detail = typeof data === 'string' ? data : JSON.stringify(data);
    if (error.response.status === 504) {
      return 'o csml-server não respondeu a tempo (use Ferramentas > Reiniciar servidor CSML)';
    }
    if (error.response.status === 502 || error.response.status === 503) {
      return 'csml-server fora do ar';
    }
    return `HTTP ${error.response.status}${detail ? ': ' + escapeHtml(detail.slice(0, 300)) : ''}`;
  }
  return escapeHtml(error.message || String(error));
}
